export class ScheduleHelper {

  static getHtmlTime(hour: number, minute: number) {
    return String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0");
  }

  static getHourMinute(htmlTime: string) {
    const parts = htmlTime.split(":");
    const hours = parseInt(parts[0], 0);
    const minutes = parseInt(parts[1], 0);
    return { hours: hours, minutes: minutes }
  }

}